/**
 * Черновик формы «Создать песню» (текст, голос, табы и т.д.) в localStorage.
 *
 * ВАЖНО про `pendingMelodySongId` внутри черновика: это ЧАСТЬ ЧЕРНОВИКА (id
 * подготовленного текста, по нему восстанавливается ввод), а НЕ признак того,
 * что пользователь что-то запускал. Решение «резюмить ли генерацию после
 * оплаты» строится на отдельном маркере намерения, который ставится только в
 * обработчике 402 — см. `pendingSongGeneration`. Раньше резюм шёл по черновику,
 * и покупка пакета песен впрок запускала генерацию без единого клика.
 */
export const SONG_CREATION_STATE_STORAGE_KEY = "songCreationState";
export function clearSongCreationPersistedState() {
    try {
        localStorage.removeItem(SONG_CREATION_STATE_STORAGE_KEY);
    }
    catch {
        /* private mode */
    }
}
/**
 * Собирает краткий бриф незавершённого заказа песни из localStorage.
 * Возвращает `null`, если черновик не готов к оплате (нет `pendingMelodySongId`)
 * или JSON битый. Иначе — только заполненные поля (пустые опускаются).
 */
export function getSongCreationRecap() {
    try {
        const raw = localStorage.getItem(SONG_CREATION_STATE_STORAGE_KEY);
        if (!raw)
            return null;
        const s = JSON.parse(raw);
        const id = Number(s?.pendingMelodySongId);
        if (!(Number.isFinite(id) && id > 0))
            return null;
        const pick = (v) => {
            const str = typeof v === "string" ? v.trim() : "";
            return str.length ? str : undefined;
        };
        const recap = {
            title: pick(s?.customTitle),
            recipient: pick(s?.selectedRecipient?.title),
            reason: pick(s?.selectedReason?.title),
            genre: pick(s?.selectedGenre?.title),
        };
        // Хотя бы одно осмысленное поле — иначе показывать нечего.
        if (!recap.title && !recap.recipient && !recap.reason && !recap.genre) {
            return null;
        }
        return recap;
    }
    catch {
        return null;
    }
}
